import { Injectable } from '@angular/core';
import { OfficerDetailsBaseService } from '@shared/utils/officer';
import { OfficerDetailFacade } from '../data/officer-details-store.facade';

@Injectable({
  providedIn: 'root',
})
export class OfficerDetailsService implements OfficerDetailsBaseService {
  constructor(private officerFacade: OfficerDetailFacade) {}

  fetchCurrentOfficer(): void {
    this.officerFacade.updateLoggedInOfficer();
  }
}
